module.exports = __webpack_public_path__ + "static/media/MyriadPro-Light.f17ff9f1.svg";